/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationPayload } from '../models/NotificationPayload';
import type { PushSubscriptionCreate } from '../models/PushSubscriptionCreate';
import type { PushSubscriptionResponse } from '../models/PushSubscriptionResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PushNotificationsService {

    /**
     * Get Public Key
     * Get the VAPID public key for the frontend
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPublicKeyPushNotificationsPublicKeyGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/push_notifications/public-key',
        });
    }

    /**
     * Subscribe
     * Subscribe to push notifications
     * @param requestBody 
     * @returns PushSubscriptionResponse Successful Response
     * @throws ApiError
     */
    public static subscribePushNotificationsSubscribePost(
requestBody: PushSubscriptionCreate,
): CancelablePromise<PushSubscriptionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/push_notifications/subscribe',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Unsubscribe
     * Unsubscribe from push notifications
     * @param endpoint 
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unsubscribePushNotificationsUnsubscribeDelete(
endpoint: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/push_notifications/unsubscribe',
            query: {
                'endpoint': endpoint,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Send Notification
     * Send a push notification to a user
     * @param userId 
     * @param requestBody 
     * @returns any Successful Response
     * @throws ApiError
     */
    public static sendNotificationPushNotificationsSendPost(
userId: string,
requestBody: NotificationPayload,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/push_notifications/send',
            query: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
